module.exports = __webpack_public_path__ + "img/3c0f7c4a3c33b14a1dcb321e3bcb12a5.png";